import React, { FC } from 'react'
import { EditorTheme } from '../templateEditor.theme'
import { Rect } from '../templateEditor.types'
import { toDisplaySize } from '../templateEditor.utils'
import styles from './templateEditor__marquee.jcss'

type Props = {
    rect: Rect
    theme: EditorTheme
}

export const TemplateEditorMarquee: FC<Props> = ({ rect, theme }) => {
    const scale = theme.displayScale
    return (
        <div
            className={styles.marquee}
            style={{
                left: toDisplaySize(rect.x, scale),
                top: toDisplaySize(rect.y, scale),
                width: toDisplaySize(rect.w, scale),
                height: toDisplaySize(rect.h, scale),
            }}
        />
    )
}
